const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api'


class ApiService {
    constructor() {
        this.baseURL =  API_BASE_URL
        this.token = localStorage.getItem('authToken')
    }

    setToken (token) {
        this.token = token
        localStorage.setItem('authToken', token)
    }

    clearToken() {
        this.token = null
        localStorage.setItem('authToken')
    }

    async request (endpoind, options = {} ) {
        const url = `${this.baseURL}${endpoind}`

        const config = {
            headers : {
                'Content-Type': 'application/json',
                ...options.headers,
            },
            ...options
        }

        if (this.token) {
            config.headers['Authorization'] = `Bearer ${this.token}`
        }

        try {
            const response = await fetch(url, config)

            if (!response.ok){
                const errorData =  await response.json().catch(() =>{})
                throw new Error(errorData.error || `HTTP error! status: ${response.status}`) 
            }

            return await response.json()
        } catch(error) {
            console.error(`Api request failed: ${endpoind}`, error)
            throw error
        }
    }

    async login (email, password) {
        const data = await this.request('/auth/login', 
           {method: 'POST', body: JSON.stringify({email, password})
        })

        if (data.session?.access_token) {
            this.setToken(data.session.access_token)
        }

        return data
    }

    async register (userData) {
        return await this.request('/auth/regiser', {
            method: 'POST', 
            body: JSON.stringify(userData)
        })
    }

    async logout() {
        this.clearToken()
        try {
            await this.request('/auth/logout', { method: 'POST' })
            } catch (error) {
            console.error('Logout error:', error)
        }
    }

    async getProducts(params = {}) {
        // Limpia los filtros antes de construir la URL
        const cleanParams = Object.fromEntries(
          Object.entries(params).filter(
            ([_, v]) => v !== null && v !== '' && !(typeof v === 'boolean' && v === false)
          )
        );
        const queryParams = new URLSearchParams(cleanParams).toString();
        return await this.request(`/products${queryParams ? `?${queryParams}` : ''}`);
    }

    async getProductImages(productId) {
        return await this.request(`/products/${productId}/images`);
    }

    async getProduct(id) {
        return await this.request(`/products/${id}`)
    }

    async getProductBySlug(slug) {
        return await this.request(`/products/slug/${slug}`);
    }

    async getOrders(params = {}) {
        const queryParams =  new URLSearchParams(params).toString();
        return await this.request(`/orders${queryParams ? `?${queryParams}` : ''}`);
    }

    async searchProducts(query, filters = {}) {
        const params = {
            search: query,
            ...filters
        }
        return await this.getProducts(params)
    }

    async createProduct(productData) {
        return await this.request('/products', {
            method: 'POST',
            body: JSON.stringify(productData)
        })
    }

    async updateProduct(id, productData) {
        return await this.request(`/products/${id}`, {
            method: 'PUT',
            body: JSON.stringify(productData)
        })
    }

    async deleteProduct(id) {
        return await this.request(`/products/${id}`, {
            method: 'DELETE'
        })
    }

      async uploadProductImage(productId, imageFile, isPrimary = false) {
    const formData = new FormData()
    formData.append('image', imageFile)
    formData.append('isPrimary', isPrimary.toString())

    return await this.request(`/products/${productId}/images`, {
      method: 'POST',
      headers: {}, // Remover Content-Type para FormData
      body: formData
    })
  }

    // Categorías
    async getCategories() {
        return await this.request('/categories')
    }

    // Atributos de producto
    async getProductAttributes() {
        return await this.request('/product-attributes');
    }

    async createProductAttribute(name) {
        return await this.request('/product-attributes', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ name })
        });
    }
}

export const apiService = new ApiService()

export async function uploadImage(file) {
    const formData = new FormData();
    formData.append('file', file);
    const res = await fetch(`${API_BASE_URL.replace(/\/api$/, '')}/api/upload-image`, {
        method: 'POST',
        body: formData,
    });
    return await res.json();
}

export async function createProduct(productData) {
    const res = await fetch(`${API_BASE_URL}/products`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(productData),
    });
    return await res.json();
}

